/**
 * @module  Experience/Softgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Libraries
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
// Interfaces
import { ProductSelectorConfigData } from '@core/aem/interfaces/product-selector/product-selector.interface';

// Constants
import { LineDeivceDetails } from '@experience/shop/product-selector/interfaces/product-selector.interface';

@Component({
  selector: 'tmo-selected-plan',
  templateUrl: './selected-plan.component.html',
  styleUrls: ['../../../../../../style-sheets/components/input-radio.component.scss'],
})
export class SelectedPlanComponent implements OnInit, OnDestroy {
  /**
   * AEM content for product selector page
   */
  @Input() public aemContent: ProductSelectorConfigData;

  @Input() public set focusedTileIdDetails(value: LineDeivceDetails) {
    this.focusedDetails = value;
  }
  public focusedDetails: LineDeivceDetails;
  /**
   * Holds true if focused customer is Existing line
   */
  @Input() public isExistingLine: boolean;
  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;
  /**
   * Holds value of digitalPlansView
   */
  @Input() public digitalPlansView: boolean;

  constructor() {
    this.ngUnsubscribe = new Subject<void>();
  }

  public ngOnInit(): void {}

  /**
   * Destroys all the subscriptions
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
